import { jsx as s } from "react/jsx-runtime";
import i from "react";
import { i as l } from "../../type-BFTbooL7.js";
import I from "../InputContainer/index.js";
import K from "../RawTextArea/index.js";
const u = "•", R = "Enter";
function L(c) {
  const {
    actions: m,
    className: p,
    disabled: r,
    error: f,
    errorOnTooltip: d,
    hint: C,
    icons: N,
    inputClassName: h,
    label: T,
    labelClassName: b,
    readOnly: o,
    required: v,
    variant: E,
    inputSectionClassName: k,
    withAsterisk: x,
    onChange: e,
    name: t,
    autoBullets: n = !1,
    rows: y = 5,
    ...g
  } = c, w = i.useCallback((a) => {
    l(e) || a.target.value === "" && e(`${u} `, t);
  }, [e, t]), A = i.useCallback((a) => {
    l(e) || a.key === R && e(`${a.currentTarget.value}${u} `, t);
  }, [e, t]);
  return /* @__PURE__ */ s(
    I,
    {
      actions: m,
      className: p,
      disabled: r,
      error: f,
      errorOnTooltip: d,
      hint: C,
      icons: N,
      inputSectionClassName: k,
      labelClassName: b,
      label: T,
      readOnly: o,
      required: v,
      variant: E,
      withAsterisk: x,
      input: /* @__PURE__ */ s(
        K,
        {
          ...g,
          readOnly: o,
          disabled: r,
          className: h,
          onChange: e,
          name: t,
          onFocus: n ? w : void 0,
          onKeyUp: n ? A : void 0,
          rows: y
        }
      )
    }
  );
}
export {
  L as default
};
